import React from "react";

import Link from "next/link";

import CheckCircle from "assets/iconsv2/check-circle-16.svg";
import ArrowRight from "assets/iconsv2/arrow-right-16.svg";
import Button from "components/Button";

import styles from "./TeamsPricingInfo.module.css";

const TeamsPricingInfo: React.FC = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.plans}>
          <div className={styles.freePlan}>
            <strong>Free Teams Plan</strong>
            <span className={styles.perMonth}>
              <strong>$0</strong> per month
            </span>
            <Link href="/teams/redirect" passHref>
              <Button renderAs="a">Create Organization</Button>
            </Link>
            <hr />
            <div>
              <span>What&rsquo;s included</span>
              <ul className={styles.featureList}>
                <li>
                  <i>
                    <CheckCircle className="icon" />
                  </i>
                  Up to 5 Shared Commands
                </li>
                <li>
                  <i>
                    <CheckCircle className="icon" />
                  </i>
                  Up to 30 Shared Quicklinks
                </li>
                <li>
                  <i>
                    <CheckCircle className="icon" />
                  </i>
                  Up to 30 Shared Snippets
                </li>
                <li>
                  <i>
                    <CheckCircle className="icon" />
                  </i>
                  Private Store
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.paidPlan}>
            <strong>Paid Teams Plan</strong>
            <span className={styles.perMonth}>
              <strong>$10</strong> per user, per month
            </span>
            <Link href="/teams/redirect" passHref>
              <Button renderAs="a">Create Organization</Button>
            </Link>
            <hr />
            <div>
              <span>What&rsquo;s included</span>
              <ul className={styles.featureList}>
                <li>
                  <i>
                    <CheckCircle className="icon" />
                  </i>
                  Unlimited Shared Commands
                </li>
                <li>
                  <i>
                    <CheckCircle className="icon" />
                  </i>
                  Unlimited Shared Quicklinks
                </li>
                <li>
                  <i>
                    <CheckCircle className="icon" />
                  </i>
                  Unlimited Shared Snippets
                </li>
                <li>
                  <i>
                    <CheckCircle className="icon" />
                  </i>
                  Private Store
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.bgImg}></div>
      </div>

      <div className={styles.enterpriseContainer}>
        <a href="mailto:hello+enterprise@raycast.com" className={styles.enterprise}>
          Want enterprise features?
          <strong>
            Get in touch
            <i>
              <ArrowRight className="icon" />
            </i>
          </strong>
        </a>
      </div>
    </>
  );
};

export default TeamsPricingInfo;
